import styled, { createGlobalStyle } from "styled-components";
import type { IRegisterButtonProps } from "./types";
import { theme } from "../../styles/theme";
import { colors } from "../../styles/colors";

const ButtonStyles = createGlobalStyle`
  button {
    padding: 0.75rem 2rem;
    border-radius: 8px;
    border: none;
    font-size: 1.2rem;
    font-weight: bold;
    text-decoration: none;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      position: absolute;
      left: 30px;
      top: 12px;
      width: 30px;
      height: 30px;
      object-fit: contain;
    }
    @media (max-width: 414px) {
      font-size: 14px;
    }
  }
`;

const Primary = styled.button`
  color: #fff;
  background: #ec6726;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  margin: 1rem 0px;
  border: none;
  font-size: 1.2rem;
  font-weight: bold;
  width: 25rem;
  height: 3rem;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    left: 30px;
    top: 12px;
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

const Danger = styled.button`
  color: #fff;
  background: ${theme.colors.error};
  padding: 0.75rem 2rem;
  border-radius: 6px;
  margin: 1rem 0px;
  border: none;
  font-size: 1.2rem;
  font-weight: bold;
  width: 25rem;
  height: 3rem;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    left: 30px;
    top: 12px;
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

const AzulSenne = styled.button`
  color: #fff;
  background: #0dcaf0;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  margin: 1rem 0px;
  border: none;
  font-size: 1rem;
  font-weight: bold;
  width: 100%;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    left: 30px;
    top: 12px;
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

const OrangeSenne = styled.button`
  color: #fff;
  background: ${colors.orangeSenne};
  padding: 0.75rem 2rem;
  border-radius: 8px;
  margin: 1rem 0px;
  border: none;
  font-size: 1.2rem;
  font-weight: bold;
  width: 100%;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    left: 30px;
    top: 12px;
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

const PrimaryResults = styled.button`
  color: #fff;
  background: #f3953f;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  margin: auto;
  border: none;
  font-size: 1rem;
  font-weight: bold;
  width: 100%;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    left: 20px;
    top: 5px;
    width: 16px;
    height: 16px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

const Cancel = styled.button`
  color: #fff;
  background: #343a40;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  margin: auto;
  border: none;
  font-size: 1rem;
  font-weight: bold;
  width: 100%;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    left: 10px;
    top: 5px;
    width: 16px;
    height: 16px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

const Gray = styled.button`
  color: #fff;
  background: #c4c4c4;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  margin: 1rem 0px;
  border: none;
  font-size: 1.2rem;
  font-weight: bold;
  width: 25rem;
  height: 3rem;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    left: 30px;
    top: 12px;
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

const PrimaryTable = styled.button`
  color: #fff;
  background: #f3953f;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  margin: auto;
  border: none;
  font-size: 12px;
  font-weight: bold;
  height: 3rem;
  width: 100%;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: relative;
    top: 0;
    left: -4px;
    width: 16px;
    height: 16px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

const Register = styled.button<IRegisterButtonProps>`
  color: #fff;
  background: ${(props) => (props.background ? props.background : "#ec6726")};
  border-radius: 8px;
  padding: 6px;
  border: none;
  font-size: 1rem;
  font-weight: bold;
  width: 100%;
  height: 3rem;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    left: 30px;
    top: 12px;
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
  :disabled {
    opacity: 0.5;
  }
`;

const Secondary = styled.button`
  color: #ec6726;
  background: #fff;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  margin: 1rem 0px;
  border: none;
  font-size: 1.2rem;
  font-weight: bold;
  width: 25rem;
  height: 3rem;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    left: 30px;
    top: 12px;
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

const Outline = styled.button`
  color: #ec6726;
  background: #fff;
  border: 1px solid #ec6726;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  margin: 1rem 0px;
  font-size: 1.2rem;
  font-weight: bold;
  width: 100%;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    left: 30px;
    top: 12px;
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

const Green = styled.button`
  color: #fff;
  background: #b9bd5c;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  margin: 1rem 0px;
  border: none;
  font-size: 1rem;
  font-weight: bold;
  width: 100%;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    left: 30px;
    top: 12px;
    width: 30px;
    height: 30px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

export const ButtonArc = styled.button<{ color?: string }>`
  color: #fff;
  background: ${props => props.color};
  padding: 0.75rem 2rem;
  border-radius: 8px;
  margin: auto;
  border: none;
  font-size: 1rem;
  font-weight: bold;
  width: 100%;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    left: 20px;
    top: 5px;
    width: 16px;
    height: 16px;
    object-fit: contain;
  }
  @media (max-width: 414px) {
    font-size: 14px;
  }
`;

const Loggin = styled.div<IRegisterButtonProps>`
  color: #fff;
  flex: 1;
  background-color: ${theme.colors.secondary};
  align-items: center;
  span {
    display: flex;
    justify-content: center;
    flex-grow: 1;
    text-align: center;
  }
  display: flex;
  padding: 0.75rem 2rem;
  border-radius: 8px;
  margin: 0;
  font-size: 1rem;
  font-weight: bold;
  width: 100%;
  img {
    left: 30px;
    top: 12px;
    width: 20px;
    height: 20px;
  }
  @media (max-width: 950px) {
    font-size: 0.8rem;
    img {
      left: 30px;
      top: 12px;
      width: 15px;
      height: 15px;
    }
  }
  @media (max-width: 800px) {
    flex-wrap: wrap;
    display: flex;
  }
  @media (max-width: 500px) {
    flex-wrap: wrap;
    display: flex;
    column-gap: 0.5rem;
    span {
      display: flex;
      justify-content: unset;
      flex-grow: unset;
      text-align: unset;
    }
  }
`;

const Back = styled.button`
  border-radius: 6px;
  border: none;
  font-size: 1.2rem;
  font-weight: bold;
  gap: 6px;
  text-decoration: none;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: fit-content;
  max-height: fit-content;

  padding: 6px 12px;
  color: #4a4b4bff;
  width: 100px;
`;

export {
  ButtonStyles,
  Primary,
  Danger,
  AzulSenne,
  Secondary,
  Green,
  Gray,
  Back,
  Outline,
  Register,
  PrimaryResults,
  PrimaryTable,
  Cancel,
  OrangeSenne,
  Loggin,
};
